import { MessageSquare } from 'lucide-preact';

export function MessageSkeleton() {
  return (
    <div class="space-y-4 p-3 sm:p-4 h-full flex flex-col justify-end animate-fade-in select-none">
      {/* Loading Banner Badge */}
      <div class="flex justify-center my-2">
        <div class="flex items-center gap-2 px-3 py-1 bg-slate-900/90 border border-cyan-500/30 text-cyan-400 text-[11px] font-medium rounded-full shadow-lg backdrop-blur-md animate-pulse">
          <MessageSquare class="w-3.5 h-3.5 text-cyan-400 animate-spin" />
          <span>Carregando histórico da conversa...</span>
        </div>
      </div>

      {/* Date Divider Skeleton */}
      <div class="flex justify-center my-2">
        <div class="w-24 h-5 bg-slate-800/60 rounded-full border border-slate-700/40 animate-pulse" />
      </div>

      {/* Message Bubble 1 - Received (Left) */}
      <div class="flex items-start gap-2.5 max-w-[85%] sm:max-w-[70%]">
        <div class="w-8 h-8 rounded-full bg-slate-800 border border-slate-700/50 shrink-0 animate-pulse" />
        <div class="space-y-2 p-3.5 bg-slate-900/80 border border-slate-800/70 rounded-2xl rounded-tl-xs shadow-md w-64 animate-pulse">
          <div class="w-20 h-3 bg-slate-800 rounded-md" />
          <div class="space-y-1.5">
            <div class="w-full h-3 bg-slate-800/80 rounded-md" />
            <div class="w-4/5 h-3 bg-slate-800/80 rounded-md" />
          </div>
          <div class="flex justify-end pt-1">
            <div class="w-10 h-2 bg-slate-800/60 rounded-md" />
          </div>
        </div>
      </div>

      {/* Message Bubble 2 - Sent (Right) */}
      <div class="flex justify-end my-1">
        <div class="space-y-2 p-3.5 bg-cyan-950/40 border border-cyan-800/40 rounded-2xl rounded-tr-xs shadow-md w-56 animate-pulse">
          <div class="space-y-1.5">
            <div class="w-full h-3 bg-cyan-900/40 rounded-md" />
            <div class="w-3/5 h-3 bg-cyan-900/40 rounded-md" />
          </div>
          <div class="flex justify-end items-center gap-1 pt-1">
            <div class="w-10 h-2 bg-cyan-900/30 rounded-md" />
            <div class="w-3 h-3 bg-cyan-900/40 rounded-full" />
          </div>
        </div>
      </div>

      {/* Message Bubble 3 - Received Media Attachment Skeleton (Left) */}
      <div class="flex items-start gap-2.5 max-w-[85%] sm:max-w-[70%]">
        <div class="w-8 h-8 rounded-full bg-slate-800 border border-slate-700/50 shrink-0 animate-pulse" />
        <div class="space-y-2 p-3 bg-slate-900/80 border border-slate-800/70 rounded-2xl rounded-tl-xs shadow-md w-72 animate-pulse">
          <div class="w-24 h-3 bg-slate-800 rounded-md" />
          {/* Media placeholder rectangle */}
          <div class="w-full h-36 bg-slate-800/70 rounded-xl border border-slate-700/40 flex items-center justify-center">
            <div class="w-10 h-10 rounded-full bg-slate-700/50 flex items-center justify-center">
              <div class="w-5 h-5 rounded-full bg-slate-600/50" />
            </div>
          </div>
          <div class="w-3/4 h-3 bg-slate-800/80 rounded-md" />
          <div class="flex justify-end pt-1">
            <div class="w-10 h-2 bg-slate-800/60 rounded-md" />
          </div>
        </div>
      </div>

      {/* Message Bubble 4 - Sent (Right) */}
      <div class="flex justify-end my-1">
        <div class="space-y-2 p-3.5 bg-cyan-950/40 border border-cyan-800/40 rounded-2xl rounded-tr-xs shadow-md w-64 animate-pulse">
          <div class="space-y-1.5">
            <div class="w-full h-3 bg-cyan-900/40 rounded-md" />
            <div class="w-4/5 h-3 bg-cyan-900/40 rounded-md" />
            <div class="w-1/2 h-3 bg-cyan-900/40 rounded-md" />
          </div>
          <div class="flex justify-end items-center gap-1 pt-1">
            <div class="w-10 h-2 bg-cyan-900/30 rounded-md" />
            <div class="w-3 h-3 bg-cyan-900/40 rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
}
